import React from "react";
import Table, { KebabMenu } from "../../../components/Common/Table";
import Button from "../../../components/Common/Button";
import { branchTableColumns, BRANCHES_PAGE_TITLE } from "../dataFiles/branchesPageDataFile";

export default function BranchTable({ branches = [], onSelect, onEdit, onDelete, onAddBranch, activeBranchId, canEdit = false }) {
  const columns = [
    ...branchTableColumns,
    {
      key: "actions",
      header: "Actions",
      align: "right",
      width: "80px",
      render: (row) => (
        <div className="wg-table__actions">
          <KebabMenu
            items={[
              { label: "Edit", onClick: () => onEdit(row), disabled: !canEdit },
              { label: "Delete", onClick: () => onDelete(row), disabled: true },
            ]}
          />
        </div>
      ),
    },
  ];

  return (
    <Table
      columns={columns}
      data={branches}
      rowKey="id"
      activeRowKey={activeBranchId}
      hoverable
      onRowClick={onSelect}
      emptyState="No branches found."
      toolbar={{
        left: <h2 className="wg-page-header">{BRANCHES_PAGE_TITLE}</h2>,
        right: onAddBranch && (
          <Button onClick={onAddBranch}>+ Add Branch</Button>
        ),
      }}
    />
  );
}
